import { render, staticRenderFns } from "./PostFocus.vue?vue&type=template&id=6d972bc4&scoped=true"
import script from "./PostFocus.vue?vue&type=script&lang=js"
export * from "./PostFocus.vue?vue&type=script&lang=js"
import style0 from "./PostFocus.vue?vue&type=style&index=0&id=6d972bc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d972bc4",
  null
  
)

export default component.exports